import { render, staticRenderFns } from "./EditionBadge.vue?vue&type=template&id=27585133&scoped=true"
import script from "./EditionBadge.vue?vue&type=script&lang=js"
export * from "./EditionBadge.vue?vue&type=script&lang=js"
import style0 from "./EditionBadge.vue?vue&type=style&index=0&id=27585133&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27585133",
  null
  
)

export default component.exports